module.exports = __webpack_public_path__ + "img/7200.0234bbc7.svg";